// components/product/ProductFormSections.tsx
"use client";
import { DescriptionSection } from "./sections/EditDescriptionSection";
import { AboutSection } from "./sections/EditAboutSection";
import { KeyFeaturesSection } from "./sections/EditKeyFeaturesSection";
import { MechCharSection } from "./sections/EditMechCharSection";
import StandardsSection from "./sections/EditStandardsSection";
import FireStanSection from "./sections/EditFireStanSection";
import PhysCharSection from "./sections/EditPhysCharSection";
import { HighlightsSection } from "./sections/EditHighlightSection";

interface ProductFormSectionsProps {
  currentLang: "en" | "fa";
  openSections: Record<string, boolean>;
  onSectionToggle: (key: string) => void;

  onHighlightImageChange?: (
    file: File,
    highlightUuid: string
  ) => Promise<void>;
  onHighlightAssetPick?: (highlightUuid: string) => void;
  submitAttempted?: boolean;
}

export function ProductFormSections({
  currentLang,
  openSections,
  onSectionToggle,
  onHighlightImageChange,
  onHighlightAssetPick,
  submitAttempted = false,
}: ProductFormSectionsProps) {

  
  return (
    <>
      <DescriptionSection
        currentLang={currentLang}
        isOpen={openSections["desc"]}
        onToggle={() => onSectionToggle("desc")}
        submitAttempted={submitAttempted}
      />

      <AboutSection
        currentLang={currentLang}
        isOpen={openSections["about"]}
        onToggle={() => onSectionToggle("about")}
      />

      <KeyFeaturesSection
        currentLang={currentLang}
        isOpen={openSections["key_features"]}
        onToggle={() => onSectionToggle("key_features")}
        submitAttempted={submitAttempted}
      />

      <MechCharSection
        currentLang={currentLang}
        isOpen={openSections["mech_char"]}
        onToggle={() => onSectionToggle("mech_char")}
        submitAttempted={submitAttempted}
      />

      <StandardsSection
        currentLang={currentLang}
        isOpen={openSections["standards"]}
        onToggle={() => onSectionToggle("standards")}
        submitAttempted={submitAttempted}
      />

      <FireStanSection
        currentLang={currentLang}
        isOpen={openSections["fire_stans"]}
        onToggle={() => onSectionToggle("fire_stans")}
        submitAttempted={submitAttempted}
      />

      <PhysCharSection
        currentLang={currentLang}
        isOpen={openSections["phys_char"]}
        onToggle={() => onSectionToggle("phys_char")}
        submitAttempted={submitAttempted}
      />

      <HighlightsSection
        currentLang={currentLang}
        onHighlightImageChange={onHighlightImageChange}
        onHighlightAssetPick={onHighlightAssetPick}
        isOpen={openSections["highlights"]}
        onToggle={() => onSectionToggle("highlights")}
        submitAttempted={submitAttempted}
      />
    </>
  );
}
